angular.module('filters.myBookmarkedSearches', [])
  .filter('myBookmarkedSearches', function () {
    return function (input) {
      return _.filter(input, function (item) {
        return item.consultant_id === devex.data.user.id;
      });
    };
  });

angular.module('filters.sharedBookmarkedSearches', [])
  .filter('sharedBookmarkedSearches', function () {
    return function (input) {
      return _.filter(input, function (item) {
        return item.consultant_id !== devex.data.user.id;
      });
    };
  });
